import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

/**
 * Checks a field again as soon as it changes while it shows an error, so the message goes away
 * the moment the answer is valid. react-hook-form does this on its own only after a submit, and a
 * step of a form is checked with `trigger`, so "Dieses Feld ist erforderlich" stayed under a choice
 * the user had already made until the next "Weiter". A field without an error is left alone: the
 * form still says nothing before the user tries to go on.
 */
export const useRevalidateFieldsWithErrors = formMethods => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== formMethods) {
    t0 = () => {
      const subscription = formMethods.watch((_values, t2) => {
        const {
          name
        } = t2;
        if (name === undefined) {
          return;
        }
        if (formMethods.getFieldState(name).error === undefined) {
          return;
        }
        formMethods.trigger(name);
      });
      return () => subscription.unsubscribe();
    };
    t1 = [formMethods];
    $[0] = formMethods;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};